import config from '@/config.js';
import staticCountries from './static/countries';

export default {
    namespaced: true,

    state: () => ({
        countries: [],
        hobbies: [],
        dating_interests: [],
        loaded: false,
    }),

    getters: {
        countries: state => {
            return state.countries.length ? state.countries : staticCountries;
        },
        lookingForList: state => [
            {'text': 'Women', 'id': 'women'},
            {'text': 'Men', 'id': 'men'},
        ],
        civilStatuses: state => [
            { id: 'single', text: 'Single' },
            { id: 'married', text: 'Married' },
            { id: 'divorced', text: 'Divorced' },
            { id: 'widowed', text: 'Widowed' },
            { id: 'separated', text: 'Separated' },
            { id: 'never_married', text: 'Never married' },
            { id: 'marital_status', text: 'Marital status' },
            { id: 'married_not_separated', text: 'Married, not separated' },
            { id: 'common_law_marriage', text: 'Common law marriage' },
        ],
        hobbies: state => state.hobbies,
        dating_interests: state => state.dating_interests,
    },

    mutations: {
        setMisc(state, data) {
            data.forEach(e => {
                state[e.key] = e.value;
            });

            state.loaded = true;
        },
    },

    actions: {
        async get({commit}) {
            const r = await window.http.get(`${config.API_URL}/misc`);

            if (r.success) {
                commit('setMisc', r.data);
            }

            return r;
        },
    }
};
